import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import { CompleteProjectStepDocument, type Step } from 'graphql/generated/graphql';

const useCompleteProjectStep = (projectId: string) => {
  const [completeProjectStepMutation] = useMutation(CompleteProjectStepDocument);

  const completeProjectStep = useCallback(
    async (step: Step) => {
      try {
        await completeProjectStepMutation({ variables: { projectId, step } });
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [completeProjectStepMutation, projectId],
  );

  return completeProjectStep;
};

export default useCompleteProjectStep;
